import { Reducer } from 'redux';

import { loadApp } from '../services/app';
import { ActionTypes } from '../types/action-types';
import { ActionObject, IApp } from '../types/app';

export default ((state = loadApp(), action: ActionObject): IApp => {
  switch (action.type) {
    case ActionTypes.HB_UI_INTEGRATE_UPDATED:
      return {
        ...state,
        configuredExpanded: action.configuredExpanded,
      };
    case ActionTypes.HB_UI_BYOD_UPDATED:
      return {
        ...state,
        byodExpanded: action.byodExpanded,
      };
  }
  return {...state};
}) as Reducer<IApp>;



// WEBPACK FOOTER //
// ./src/sub-projects/hubspot/reducers/app.ts